module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/e7db9233bdad32581beaf13e0162703a.png";